import React from "react";
import Styled from "styled-components";
import { Col } from "react-bootstrap";

const Container = Styled(Col).attrs({
    className: "col-lg-4 col-md-6 col-12",
})`
    display: flex;
    justify-content: flex-start;
    align-items: center;
`;

const Application = Styled.div`
    
    width: 100%;
    
    display: flex;
    justify-content: left;
    align-items: center;

    border-radius: 5px;

    cursor: pointer;

    color: ${(props) => (props.checked ? "var(--green-3)" : "var(--gray-2)")};

    transition: 150ms;

    &:hover span {
        opacity: 70%;
        color: var(--green-3); 
    }

`;

const Index = ({ label, checked, onClick }) => {
    return (
        <Container>
            <Application checked={checked} onClick={onClick}>
                <span>{label}</span>
            </Application>
        </Container>
    );
};

export default Index;
